import React, { useEffect, useState } from 'react';
import { getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';
import TableVendor from './TableVendor';
import KitLoader from '../../components/kitsters/KitLoader';

const VendorAttachmentCheck = () => {
  const [vendordata, setvendordata] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(window.location.search);

  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let data = await getdatanoauth({ sortcolumn:"outstanding_payable_amount_bcy", zohodatatype: 'contacts', _adminuserid: adminuserid, tag:"checkattachment" }, '/zohodatanoauth');
    setvendordata(data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Vendors with missing attachments | Problem count: {vendordata.length}</h3>
      <TableVendor vendordata={vendordata} />
    </div>
  );
};

export default VendorAttachmentCheck;